import getButtonPresets from './button-presets';

const getButtonPreset = (state, id) => {
  const buttonPresets = getButtonPresets(state);

  return buttonPresets.find((buttonPreset) => buttonPreset.id === id) || null;
};

export default getButtonPreset;
